'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.captureInstructor = exports.captureExtraAdvertiserData = exports.advertiserKeys = exports.fetchingInstructors = exports.fetchingAdvertisers = exports.instructorsError = exports.advertisersError = exports.instructors = exports.advertisers = undefined;
var _reselect = require('reselect');
var _constants = require('../constants');
var _fieldInfo = require('./field-info');
var introducerSelect = function introducerSelect(state, formId) {
  return state[_constants.NAME][formId] ? state[_constants.NAME][formId].introducerSelect : {};
};
var advertisers = exports.advertisers = function advertisers(state, formId) {
  return introducerSelect(state, formId).advertisers || [];
};
var instructors = exports.instructors = function instructors(state, formId) {
  return introducerSelect(state, formId).instructors || [];
};
var advertisersError = exports.advertisersError = function advertisersError(state, formId) {
  return introducerSelect(state, formId).advertisersError;
};
var instructorsError = exports.instructorsError = function instructorsError(state, formId) {
  return introducerSelect(state, formId).instructorsError;
};
var fetchingAdvertisers = exports.fetchingAdvertisers = function fetchingAdvertisers(state, formId) {
  return introducerSelect(state, formId).fetchingAdvertisers;
};
var fetchingInstructors = exports.fetchingInstructors = function fetchingInstructors(state, formId) {
  return introducerSelect(state, formId).fetchingInstructors;
};
var advertiserKeys = exports.advertiserKeys = function advertiserKeys(formId) {
  return (0, _reselect.createSelector)(function (state) {
    return advertisers(state, formId);
  }, function (advertisers) {
    return advertisers.map(function (advertiser) {
      return advertiser.value;
    });
  });
};
var captureExtraAdvertiserData = exports.captureExtraAdvertiserData = function captureExtraAdvertiserData(formId) {
  return (0, _reselect.createSelector)(function (state) {
    return advertisers(state, formId);
  }, function (state) {
    return (0, _fieldInfo.getValue)(state, formId, 'advertiser');
  }, function (advertisers, chosenValue) {
    var advertiser = advertisers.find(function (obj) {
      return obj && obj.value === chosenValue;
    }) || {};
    return advertiser.text !== 'Driving Instructor' && !!advertiser.captureExtraData;
  });
};
var captureInstructor = exports.captureInstructor = function captureInstructor(formId) {
  return (0, _reselect.createSelector)(function (state) {
    return advertisers(state, formId);
  }, function (state) {
    return (0, _fieldInfo.getValue)(state, formId, 'advertiser');
  }, function (advertisers, chosenValue) {
    var advertiser = advertisers.find(function (obj) {
      return obj && obj.value === chosenValue;
    }) || {};
    return advertiser.text === 'Driving Instructor';
  });
};